import styled from 'styled-components/macro';

export const Image = styled.img``;
